import React, { FC } from 'react'
import Typography from '@mui/material/Typography'
import { PAGE_LOGIN } from '../../../constants/navigation'
import LoginFormBody from '../common/LoginFormBody/LoginFormBody'
import { Link as RouterLink } from 'react-router-dom'
import { Link } from '@mui/material'

interface ILoginResetPasswordSentEmailMsgProps {
	email: string
}

const LoginForgotPasswordSentEmailMsg: FC<
	ILoginResetPasswordSentEmailMsgProps
> = ({ email }: ILoginResetPasswordSentEmailMsgProps) => {
	return (
		<LoginFormBody title={'Reset password'}>
			<Typography align={'center'} paragraph sx={{ fontSize: '1.125rem', mt: 0 }}>
				<span>Reset Password request was sent to:</span>

				<br />

				<Link
					href={`mailto:${email}`}
					underline={'hover'}
					color={'grey.900'}
					sx={{ fontFamily: 'Gilroy-Medium, sans-serif', textAlign: 'center' }}
				>
					{email}
				</Link>

				<br />

				<span>
					If you didn’t receive an email, Please check your spam folder too.
				</span>
			</Typography>

			<Link
				to={`${PAGE_LOGIN}`}
				component={RouterLink}
				color={'primary'}
				sx={{ fontFamily: 'Gilroy-Medium, sans-serif', textAlign: 'center' }}
			>
				Back to login
			</Link>
		</LoginFormBody>
	)
}

export default LoginForgotPasswordSentEmailMsg
